import { render, staticRenderFns } from "./NotificationsDashboard.vue?vue&type=template&id=5d0ea3e4"
import script from "./NotificationsDashboard.vue?vue&type=script&lang=ts"
export * from "./NotificationsDashboard.vue?vue&type=script&lang=ts"
import style0 from "./NotificationsDashboard.vue?vue&type=style&index=0&id=5d0ea3e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports